<template>
    <section v-if="pageLoader">
        <div class="page-loader">
            {{ $t("loading.loading") }}
        </div>
    </section>
    <section v-else class="info-page">
        <h1 class="heading">
            {{ $t("pages.help") }}
        </h1>
        <div class="info-block" v-html="getCurrentText(pageData)"></div>
    </section>
</template>

<script>
import ApiService from '@/services/api.service';

export default {
    name: 'HelpPage',
    props: {
        i18n: Object,
    },
    data() {
        return {
            pageLoader: true,
            pageName: '',
            selectedLanguage: "",
            pageData: null,
        }
    },
    async mounted() {
        this.pageName = this.$route.name;
        try {
            await this.$store.dispatch('infoPages/get', this.pageName);
            this.pageLoader = false;
            const response = await ApiService.get('page/help/');
            this.pageData = response.data;
            console.log(this.pageData);
        } catch (error) {
            console.error('Ошибка при загрузке данных:', error);
        }
        this.selectedLanguage = localStorage.getItem("locale") || "ru";
    },
    methods: {
        getCurrentText(pageData) {
            const languageKeyMap = {
                ru: "text",
                en: "text_en",
                tr: "text_tr",
                es: "text_es",
                fr: "text_fr",
            };
            const selectedLang = localStorage.getItem("locale");
            const dataKey = languageKeyMap[selectedLang] || "text";
            return pageData[dataKey];
        },
        getCurrentTile(pageData) {
            const languageKeyMap = {
                ru: "title",
                en: "title_en",
                tr: "title_tr",
                es: "title_es",
                fr: "title_fr",
            };
            const selectedLang = localStorage.getItem("locale");
            const dataKey = languageKeyMap[selectedLang] || "text";
            return pageData[dataKey];
        },
    }
}
</script>

<style lang="scss">
@import '~@/assets/styles/pages/_info-page';
</style>
